import { PORTAL_GUIDE_URL } from '@/constants/shared';
import { ButtonProps, Icon } from '@chakra-ui/react';
import { useState } from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import { PiBook } from 'react-icons/pi';
import { NavButton, NavButtonDirection } from './nav-button';

export const HubGuideButton = ({
  direction = 'none',
  buttonStyles = {},
}: {
  direction?: NavButtonDirection;
  buttonStyles?: ButtonProps;
}) => {
  const [hovered, setHovered] = useState(false);
  return (
    <NavButton
      href={PORTAL_GUIDE_URL}
      color="fg.muted"
      target="_blank"
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      bgColor={hovered ? 'bg.muted' : 'bg'}
      position="relative"
      pl={3}
      pr={5}
      {...buttonStyles}
      direction={direction}
    >
      <PiBook />
      Portal Guide
      <Icon position="absolute" right={1} visibility={hovered ? 'visible' : 'hidden'} boxSize={4}>
        <FiArrowUpRight />
      </Icon>
    </NavButton>
  );
};
